import Layout from '../layouts/Layout'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {Titulo} from "asocomponents"
import NuevaFacturaContainer from '../../components/organismos/NuevaFacturaContainer/NuevaFacturaContainer'

function NuevaFactura() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Nueva Factura"/>
      <NuevaFacturaContainer/>
    </Layout>
  )
}

export default NuevaFactura